import React, { useContext } from "react";
import { NavLink } from "react-router-dom";

import { auth } from "../Utils/firebase";
import { AuthContext } from "../context/AuthContext";

function SlideMenu({ setIsOpen }) {
  const { logout, setUserData } = useContext(AuthContext);
  const handleLogout = (e) => {
    e.preventDefault();
    auth
      .signOut()
      .then(() => {
        // Sign-out successful.
        logout();
        setUserData(null);
      })
      .catch((error) => {
        // An error happened.
        console.log(error);
      });
  };

  const goTo = (link) => {
    let url = "";
    switch (link) {
      case "flipcard":
        url = "https://flipcard.xyz/cholis04";
        break;
      default:
        break;
    }

    if (url !== "") {
      window.open(url, "_blank", "noopener");
      // window.open(url, "_blank", "noopener noreferrer");
    }
  };

  return (
    <div className="slide-menu darkbgBlur">
      <div className="slide-head">
        <div className="toggle-menu" onClick={() => setIsOpen(false)}>
          <span></span>
          <span></span>
        </div>
      </div>
      <div className="slide-body">
        <ul>
          <li>
            <NavLink
              exact
              to="/main/dashboard"
              className="textBrand  textExtraBold"
              activeClassName="link-active-2"
            >
              Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/main/profile"
              className="textBrand textExtraBold"
              activeClassName="link-active-2"
            >
              Profile
            </NavLink>
          </li>
          <li>
            {" "}
            <NavLink
              to="/main/appearance"
              className="textBrand textExtraBold"
              activeClassName="link-active-2"
            >
              Appearance
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/main/link"
              className="textBrand textExtraBold"
              activeClassName="link-active-2"
            >
              Link
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/main/analytic"
              className="textBrand textExtraBold"
              activeClassName="link-active-2"
            >
              Analytics
            </NavLink>
          </li>
        </ul>
      </div>
      <ul className="footer-link">
        <li>
          <p className="textSmall darktextColor">
            Made with 💛 by{" "}
            <span onClick={() => goTo("flipcard")}>cholis04</span>
          </p>
        </li>
      </ul>
      <div className="slide-footer">
        <details>
          <summary className="darktextColor text">Sign Out</summary>
          <div className="button-wrap">
            <button onClick={handleLogout}>Sign Out</button>
          </div>
        </details>
      </div>
    </div>
  );
}

export default SlideMenu;
